import { Alert } from 'antd';
import type { BtlApplication } from 'api/btlApplicationForm/types';
import { useIntl } from 'react-intl';
import { OoProductItem } from '../Product/OoProductItem';

interface OoProductSummaryProps {
  caseData?: BtlApplication;
}

export function OoProductSummary({ caseData }: OoProductSummaryProps) {
  const { formatMessage } = useIntl();
  const product = caseData?.product;

  if (!product) {
    return (
      <Alert
        message={formatMessage({ id: 'ooApplicationForm.PRODUCT.noProductSelected.label' })}
        type='info'
        showIcon
      />
    );
  }

  return <OoProductItem product={product} isSelected isSelectable={false} />;
}
